import Rollbar from 'rollbar';

import Config from '../api/config';
import { rollbarNoiseFilters } from './rollbarIgnore';

export const rollbar = new Rollbar({
    accessToken: 'f29d45f4bb0e4b5fb0e6d8af44f45e28',
    captureUncaught: true,
    captureUnhandledRejections: true,
    ...rollbarNoiseFilters,
    payload: {
        environment: Config.ROLLBAR_ENV,
        client: {
            javascript: {
                source_map_enabled: true,
                code_version: process.env.REACT_APP_RELEASE_ID
            }
        }
    }
});

export const rollbarSetUserContext = userId => {
    rollbar.configure({
        payload: {
            person: { id: userId }
        }
    });
};
